export {
  type BrandedLoaderCheckColor,
  BrandedLoaderComponent,
  type BrandedLoaderSize,
} from './branded-loader.component';
